import { Injectable } from '@angular/core';

@Injectable()
export class DataService {

   sharedData: Map<string, any>;

   constructor() {
     this.sharedData = new Map();
   }

   shareData(key, value) {
     this.sharedData.set(key, value);
   }

   has(key) {
     return this.sharedData.has(key);
   }

   getSharedData(key) {
       return this.sharedData.get(key);
   }

}



// WEBPACK FOOTER //
// ./src/app/data.service.ts